/* eslint-disable no-shadow,no-param-reassign */
import _ from "lodash";

const initialState = {
  list: {}
};

export const state = initialState;

export const getters = {
  kind: state => id => _.filter(state.list, o => o.attributes.kind === id)
};

export const actions = {
  kind({ commit }, payload) {
    commit("kind", payload);
  }
};

export const mutations = {
  kind(state, data) {
    state.list = Object.assign({}, state.list, data.setting);
  }
};
